import classNames from 'classnames';
import React from 'react';
import ValidationMessage from '../../../../../validation-message';
import { AppointmentTimeLabel } from '../../../../constants';
import TimeSlot from './components/time-slot';
import styles from './styles';
import { isTimeElapsed } from '../../../../utils';

const TimeSelector = ({
  id,
  timeSlots,
  selectedTime,
  onTimeClick,
  validationMessage,
  readOnly,
  timeZone
}) => {
  const validationClass = classNames({
    'control-group error': validationMessage
  });

  const readOnlyStyle = readOnly && styles.readOnly;

  return (
    <div
      id={id}
      className="form-field-input-container"
      style={styles.inputContainer}
    >
      <div className="form-field-label primary">{`${AppointmentTimeLabel} *`}</div>
      <div
        style={{ ...styles.timeSlotSelectorContainer, ...readOnlyStyle }}
        className={validationClass}
      >
        <div style={styles.timeSlotAmPmContainer}>
          <div style={styles.timeSlotContainer}>
            {timeSlots[0].map((slot) => (
              <TimeSlot
                key={slot.time}
                time={slot.time}
                selected={slot.time === selectedTime}
                onClick={onTimeClick}
                disabled={isTimeElapsed(slot.time, timeZone) || !slot.available}
              />
            ))}
          </div>
          <div style={styles.timeSlotContainer}>
            {timeSlots[1].map((slot) => (
              <TimeSlot
                key={slot.time}
                time={slot.time}
                selected={slot.time === selectedTime}
                onClick={onTimeClick}
                disabled={
                  isTimeElapsed(slot.time, timeZone) || !slot.available
                }
              />
            ))}
          </div>
        </div>
      </div>
      <ValidationMessage message={validationMessage} />
    </div>
  );
};

TimeSelector.defaultProps = {
  timeSlots: [[], []],
  selectedTime: null,
  readOnly: false
};

export default TimeSelector;
